import { render, staticRenderFns } from "./CreateWalletInput.vue?vue&type=template&id=c34bb856&scoped=true&"
import script from "./CreateWalletInput.vue?vue&type=script&lang=js&"
export * from "./CreateWalletInput.vue?vue&type=script&lang=js&"
import style0 from "./CreateWalletInput.vue?vue&type=style&index=0&id=c34bb856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34bb856",
  null
  
)

export default component.exports